<template lang="html">

  <li
    :class="['word', {'found': word.found}, {'hintMode': hintMode}]"
    v-show="isPlaying || completed"
    @click="highlightLetter(word.word)"
  >
    {{ word.word }}
  </li>

</template>

<script lang="js">

  import { mapState, mapActions } from 'vuex'

  export default  {
    name: 'word',
    props: ['word'],

    computed: {
      ...mapState({
        isPlaying: state => state.game.isPlaying,
        completed: state => state.game.completed,
        hintMode: state => state.wordlist.letterHintMode,
      }),
    },

    methods: {
      highlightLetter(word){
        
        if(this.hintMode){
          this.LetterHighlighter(word.charAt(0))
          this.incrementHints(1) //we give a penalty of 1 for letter hints which equates to 10 seconds
        }
        
      },

      ...mapActions({
          LetterHighlighter: 'grid/highlightLetter',
          letterhintMode: 'wordlist/letterHint',
          incrementHints: 'game/incrementHintCounter',
        }),
    }
  }

</script>

<style lang="scss" scoped>
  .word {
    cursor: default;

    &.found {
      text-decoration: line-through;
      opacity: 0.6;
    }
    &.hintMode:not(.found){
      cursor: pointer;
      color: #000;
      text-decoration: underline;
    }
  }
</style>
